import { render } from "./DevUtils.vue?vue&type=template&id=2f05a244"
import script from "./DevUtils.vue?vue&type=script&lang=js"
export * from "./DevUtils.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__